import SSOCallback from './component';
export const initialState = {};
export const component = SSOCallback;